<template>
  <el-dialog
    :visible.sync="visible"
    width="80%"
    @open="handleOpen"
    :before-close="handleClose"
  >
    <div style="display: flex">
      <el-form ref="queryFormRef" :model="queryParams" :inline="true">
        <el-form-item label="批次号:" prop="uid">
          <el-input
            v-model="queryParams.uid"
            placeholder="请输入批次号"
            size="small"
            clearable
            @keyup.enter="handleQuery"
          />
        </el-form-item>
        <el-form-item v-if="cicadeStore.activeChannel?.id === 1" label="发送方式:" prop="greetType">
          <el-select
            v-model="queryParams.greetType"
            placeholder="请选择发送方式"
            size="small"
            clearable
          >
            <el-option label="用户名" :value="'userName'"></el-option>
            <el-option label="手机号" :value="'phoneNumber'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:" prop="type">
          <el-select
            v-model="queryParams.type"
            placeholder="请选择状态"
            size="small"
            clearable
          >
            <el-option label="已完成" :value="'success'"></el-option>
            <el-option label="进行中" :value="'running'"></el-option>
            <el-option label="等待中" :value="'wait'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="Search"
            size="small"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="Refresh" size="small" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="display: flex; margin: 0px 0 10px">
      <el-dropdown>
        <el-button type="primary" size="small">批量打招呼</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="cicadeStore.activeChannel?.id === 1" @click.native="handleUserSend"
            >批量用户名</el-dropdown-item
          >
          <el-dropdown-item v-if="cicadeStore.activeChannel?.id === 1" @click.native="handlePhoneSend"
            >批量手机号</el-dropdown-item
          >
          <el-dropdown-item v-if="cicadeStore.activeChannel?.id === 10" @click.native="handleAccountSend"
            >批量账号</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown style="margin-left: 20px;">
        <el-button type="primary" size="small">下载模版</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="cicadeStore.activeChannel?.id === 1" @click.native="downloadUserSend"
            >用户名模版</el-dropdown-item
          >
          <el-dropdown-item v-if="cicadeStore.activeChannel?.id === 1" @click.native="downloadPhoneSend"
            >手机号模版</el-dropdown-item
          >
          <el-dropdown-item v-if="cicadeStore.activeChannel?.id === 10" @click.native="downloadAccountSend"
            >账号模版</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <input
        type="file"
        ref="fileInput"
        style="display: none"
        accept=".xlsx, .xls"
        @change="handleFileChange"
      />
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        stripe
        height="400"
        style="width: 100%"
      >
        <el-table-column
          prop="uid"
          label="批次号"
          show-overflow-tooltip
          width="150"
        ></el-table-column>
        <el-table-column prop="greetType" label="类型" width="100">
          <template #default="scope">
            <el-tag
              v-if="scope.row.greetType == 'userName'"
              type=""
              size="small"
              >用户名</el-tag
            >
            <el-tag v-else-if="scope.row.greetType == 'phoneNumber'" type="success" size="small">手机号</el-tag>
            <el-tag v-else-if="scope.row.greetType == 'account'" type="warning" size="small">账号</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="发送总数"></el-table-column>
        <el-table-column prop="successNum" label="成功数"></el-table-column>
        <el-table-column prop="errNum" label="失败数"></el-table-column>
        <el-table-column label="成功率">
          <template #default="scope">
            <el-tag
              v-if="scope.row.type == 'success'"
              type="success"
              size="small"
              >{{
                calculateSuccessRate(scope.row.successNum, scope.row.count)
              }}</el-tag
            >
            <el-tag v-else type="warning" size="small">{{
              calculateSuccessRate(scope.row.successNum, scope.row.count)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="状态">
          <template #default="scope">
            <el-tag v-if="scope.row.type == 'wait'" size="small" type="warning"
              >等待中</el-tag
            >
            <el-tag
              v-else-if="scope.row.type == 'running'"
              size="small"
              type="warning"
              >进行中</el-tag
            >
            <el-tag v-else size="small" type="success">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160"
        ></el-table-column>
        <el-table-column prop="updateTime" label="结束时间" width="160">
          <template #default="scope">
            <div v-if="scope.row.type == 'success'">
              {{ scope.row.updateTime }}
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button
              type=""
              size="small"
              :disabled="scope.row.type != 'success'"
              @click="hanldeDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              type="danger"
              size="small"
              v-if="scope.row.type == 'wait'"
              :disabled="scope.row.type != 'wait'"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="batchQuery-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <batch-detail
      :visible="subVisible"
      :rowData="rowData"
      @close="subVisible = false"
    ></batch-detail>
    <batch-upload
      :type="type"
      :title="title"
      :exceldata="ExcelData"
      :visible="threeVisible"
      @close="threeVisible = false"
      @getList="handleQuery"
    ></batch-upload>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import BatchDetail from "./BatchDetail.vue";
import BatchUpload from "./BatchUpload.vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      queryParams: {
        uid: undefined,
        greetType: undefined,
        type: undefined,
        // channelName: this.cicadeStore.activeChannel.channelName,
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
      ExcelData: [],
      total: 0,
      subVisible: false,
      threeVisible: false,
      title: "",
      type: "",
      rowData: {},
    };
  },
  components: {
    BatchDetail,
    BatchUpload,
  },
  computed: {
    ...mapState(['cicadeStore']),
  },
  methods: {
    getList() {
      Object.assign(this.queryParams,{channelName: this.cicadeStore.activeChannel?.channelName});
      this.$http
        .post("/client/queryGreetTask", this.queryParams)
        .then((res) => {
          this.total = res.total;
          this.tableData = res.rows;
        });
    },
    handleOpen() {
      this.reast();
      this.getList();
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    resetQuery() {
      this.reast();
    },
    reast() {
      this.queryParams = {
        uid: undefined,
        greetType: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10,
      };
    },
    handleUserSend() {
      this.$refs.fileInput.click();
      this.title = "用户名批量发送";
      this.type = "userName";
    },
    handlePhoneSend() {
      this.$refs.fileInput.click();
      this.title = "手机号批量发送";
      this.type = "phoneNumber";
    },
    handleAccountSend() {
      this.$refs.fileInput.click();
      this.title = "账号批量发送";
      this.type = "account";
    },
    downloadPhoneSend(){
      const link = document.createElement('a');
      link.href = '/template/template.xlsx';
      link.download = '手机号模版.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadUserSend(){
      const link = document.createElement('a');
      link.href = '/template/template2.xlsx';
      link.download = '用户名模版.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadAccountSend(){
      const link = document.createElement('a');
      link.href = '/template/template3.xlsx';
      link.download = '账号模版.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = (evt) => {
        const arrayBuffer = evt.target.result;
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(sheet);
        const firstRow = json[0];
        // 字段校验逻辑
        if (this.type === "userName") {
          if (!firstRow || !("userName" in firstRow)) {
            this.$message.error('请确保 Excel 中包含表头字段 "userName"');
            return;
          }
        }
        if (this.type === "phoneNumber") {
          if (!firstRow || !("phoneNumber" in firstRow)) {
            this.$message.error('请确保 Excel 中包含表头字段 "phoneNumber"');
            return;
          }
        }
        if (this.type === "account") {
          if (!firstRow || !("account" in firstRow) || !("targetUser" in firstRow)) {
            this.$message.error('请确保 Excel 中包含表头字段 "account"和"targetUser"');
            return;
          }
        }
        if(json?.length > 200 && this.type === "account"){
          this.$message.error("最多只能导入200条数据！");
          return;
        }
        this.ExcelData = json;
        this.$message.success("导入成功！");
        this.$refs.fileInput.value = "";
        this.threeVisible = true;
      };
      reader.onerror = () => {
        this.$message.error("读取文件失败！");
      };
    },
    handleClose() {
      this.$emit("close");
    },
    hanldeDetail(row) {
      this.rowData = row;
      this.subVisible = true;
    },
    handleDelete(row) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post("/client/removeGreetTask", { uid: row.uid }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    calculateSuccessRate(successCount, totalCount) {
      if (totalCount === 0) {
        return "0%";
      }
      const rate = (successCount / totalCount) * 100;
      return rate.toFixed(1) + "%"; // 保留两位小数
    },
  },
};
</script>
<style lang="scss" scoped>
.batchQuery-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
